<template>
<div class="text">
    <h3 class="m-b-16">Text</h3>
    <div :class="$prefixClass.row">
        <a-form-model ref="formText" :model="formText" v-bind="layout" :rules="rules">
            <div class="m-b-24">
                <strong>Input text</strong>
                <a-textarea class="m-t-8" v-model="formText.text" maxlength="50" placeholder="Simple text" :rows="2" />
            </div>
            <a-form-model-item class="m-b-24" label="Font">
                <a-select :prefixCls="$prefixClass.select" v-model="formText.font">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listFont" :key="index" :value="item.value">
                        <span :style="{'font-family': item.value}">{{item.text}}</span>
                    </a-select-option>
                </a-select>
            </a-form-model-item>   
            <a-form-model-item class="m-b-24" label="Color">
                <VueColorpicker v-model="formText.color"/>
            </a-form-model-item>
            <a-form-model-item class="m-b-24" label="Size">
                <a-select :prefixCls="$prefixClass.select" v-model="formText.size">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listSize" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item label="Font weight">
                <a-select :prefixCls="$prefixClass.select" v-model="formText.fontWeight">
                    <i class="fas fa-chevron-down" slot="suffixIcon"></i>
                    <a-select-option v-for="(item, index) in listFontWeight" :key="index" :value="item.value">{{item.text}}</a-select-option>
                </a-select>
            </a-form-model-item>
        </a-form-model>
    </div>
</div>
</template>

<script>
import { listFontWeight } from './../constant'
import { listSizeText } from './../constant'
import { listFont } from './../constant'

export default {
    name: "ProgressBar",
    props: {
        value: {
            type: Object,
            required: true,
        }
    },
    computed: {
        formText: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            }
        }
    },

    data() {
        return {
            listFontWeight: listFontWeight,
            listSize: listSizeText,
            listFont: listFont,
            layout: {
                labelCol: {
                    span: 12
                },
                wrapperCol: {
                    span: 12
                },
            },
            rules: {
                text: [
                    { required: true, message: 'Please input text', trigger: 'change' },
                    { min: 3, max: 5, message: 'Length should be less than 50', trigger: 'change' },
                ]
            }
        };
    },
    watch: {
    },
    created() {},
    mounted() {
    },
    methods: {
    },
};
</script>

<style lang="scss">
    .text {
    }
</style>
